import { backendClient } from '@/api/backendClient';
import { ServiceDomainRequest } from '@/openapi/schema';

export function upsertServiceDomain(serviceDomainId: string, request: ServiceDomainRequest) {
  return backendClient.PATCH('/service-now/service-domains/{serviceDomainId}', {
    params: {
      path: {
        serviceDomainId,
      },
    },
    body: request,
  });
}

export function deleteServiceDomain(serviceDomainId: string) {
  return backendClient.DELETE('/service-now/service-domains/{serviceDomainId}', {
    params: {
      path: {
        serviceDomainId,
      },
    },
  });
}
